import * as React from 'react';
import { Grid, Typography, styled, Skeleton } from '@mui/material';
import IOSSwitch from 'src/components/IosSwitch';
import { ContainerCard } from 'src/style/common';
export interface NotificationElement {
  title: string;
  description: string;
  status: boolean;
}

export interface Props {
  singleNotification: NotificationElement;
  updateNotification: (notificationName: string, status: boolean) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

const GridMarginBottom = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const GridMarginBottomContentLeft = styled(GridMarginBottom)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

const TypoMarginBottom = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}));

const TypoMarginBottomDescription = styled(TypoMarginBottom)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

const SwitchWrapper = styled(IOSSwitch)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const Notification: React.FC<Props> = ({ singleNotification, updateNotification, isLoading, isDisabled }) => {
  const [switchStatus, setSwitchStatus] = React.useState<boolean>(singleNotification.status);

  const handleCheckStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSwitchStatus(event.target.checked);
    updateNotification(singleNotification.title, event.target.checked);
  };

  return (
    <>
      <GridMarginBottom item={true} xs={6} md={8}>
        <ContainerCard>
          <TypoMarginBottom variant="subtitle1">
            {isLoading ? <Skeleton variant="rectangular" width="90px" height={20} /> : singleNotification.title}
          </TypoMarginBottom>
          <TypoMarginBottomDescription variant="body2">
            {isLoading ? <Skeleton variant="rectangular" width={Math.floor(Math.random() * 350) + 100} height={20} /> : singleNotification.description}
          </TypoMarginBottomDescription>
        </ContainerCard>
      </GridMarginBottom>
      <GridMarginBottomContentLeft item={true} xs={6} md={4}>
        {isLoading ? (
          <Skeleton variant="rectangular" width="48px" height={18} style={{ marginRight: 8 }} />
        ) : (
          <SwitchWrapper checked={switchStatus} disabled={isDisabled || false} onChange={handleCheckStatus} />
        )}
      </GridMarginBottomContentLeft>
    </>
  );
};

export default Notification;
